// src/pages/bloomterminal/alerts/components/AlertTypeToggle.jsx
import React from 'react';
import { useGlobalFontSize } from '../../../context/GlobalFontSizeContext';
import { useTheme } from '../../../context/ThemeContext';

const ALERT_TYPE_OPTIONS = [
  {
    id: 'smart',
    label: 'Smart',
  },
  {
    id: 'custom',
    label: 'Custom',
  },
];

const AlertTypeToggle = ({ alertType, onAlertTypeChange }) => {
  const { fontSize } = useGlobalFontSize();
  const { isDark } = useTheme();
  return (
    <div className="flex gap-4 items-center">
      {ALERT_TYPE_OPTIONS.map((option) => {
        const isActive = alertType === option.id;
        return (
          <button
            key={option.id}
            onClick={() => onAlertTypeChange(option.id)}
            className={`px-6 py-2 rounded-[8px] font-['Inter'] font-medium transition-colors ${
              isActive
                ? 'bg-bloom-green text-white'
                : 'text-[#828382] dark:text-[#5d625f] hover:text-[#282A29] dark:hover:text-[#f0f5f2]'
            }`}
            style={{ fontSize: fontSize + 2 }}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default AlertTypeToggle;

